<template>
  <div
    class="card-integracoes"
    :class="{ 'card-integracoes--clicavel': clicavel, 'card-integracoes--apagada': apagada }"
    @click="aoClicar"
  >
    <div class="card-integracoes__topo">
      <slot name="logo" />

      <div class="card-integracoes__selos">
        <slot name="selos" />
      </div>
    </div>

    <div class="card-integracoes__corpo">
      <div class="card-integracoes__nome">
        <slot name="nome" />
      </div>
      <div class="card-integracoes__subtitulo">
        <slot name="subtitulo" />
      </div>

      <slot />
    </div>

    <slot name="rodape-livre" />

    <div v-if="$slots.rodape" class="card-integracoes__rodape">
      <slot name="rodape" />
    </div>
  </div>
</template>

<script>
/*
 * A moldura dos cards do módulo de Integrações.
 *
 * O catálogo e a lista de configuradas mostram coisas diferentes — um oferece
 * o que dá para instalar, o outro o que já está no ar, com ações e estado —,
 * mas são a mesma prateleira, vista em dois momentos. Eram dois componentes
 * com a mesma anatomia escrita duas vezes, e já tinham começado a divergir:
 * padding, sombra do hover e cabeçalho não batiam.
 *
 * Aqui fica só a moldura (topo com marca e selos, corpo, rodapé) e o que é
 * específico entra por slot. Uma mudança de estilo passa a valer para as duas
 * telas de uma vez.
 */
export default {
  name: 'CardBase',
  props: {
    // Card do catálogo abre o conector ao ser clicado; o de uma integração já
    // configurada tem botões próprios e não reage ao clique na área toda.
    clicavel: {
      type: Boolean,
      default: false,
    },
    // Integração desligada fica recuada, sem sumir da lista.
    apagada: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    aoClicar(evento) {
      if (this.clicavel) {
        this.$emit('click', evento);
      }
    },
  },
};
</script>

<style scoped>
.card-integracoes {
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}

.card-integracoes--clicavel {
  cursor: pointer;
}

.card-integracoes:hover {
  border-color: #3a3e81;
  box-shadow: 0 4px 12px rgba(58, 62, 129, 0.1);
  transform: translateY(-2px);
}

.card-integracoes--apagada {
  background: #fcfcfd;
}

.card-integracoes--apagada .card-integracoes__topo,
.card-integracoes--apagada .card-integracoes__corpo {
  opacity: 0.65;
}

.card-integracoes__topo {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 0;
}

.card-integracoes__selos {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.card-integracoes__corpo {
  flex: 1;
  padding: 14px 20px 16px;
}

.card-integracoes__nome {
  font-weight: 600;
  font-size: 15px;
  color: #1d2939;
}

.card-integracoes__subtitulo {
  font-size: 12px;
  color: #2298a3;
  font-weight: 500;
  margin-top: 2px;
}

.card-integracoes__rodape {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #e9ecef;
  background: #fcfcfd;
  font-size: 12px;
}

/*
 * Botão não encolhe nem quebra por dentro.
 *
 * Sem isto, um rótulo que cresce — "Testar" virando "Testando..." — fazia o
 * conteúdo do botão quebrar em duas linhas, com o ícone em cima do texto, e a
 * altura do rodapé inteiro aumentava junto. Faltando espaço, o botão inteiro
 * desce para a linha de baixo, que é o que o usuário entende como falta de
 * espaço.
 */
.card-integracoes__rodape > * {
  flex-shrink: 0;
  white-space: nowrap;
}
</style>
